@if(isLoading) {
<app-loader></app-loader>
}
<div class="logo-container">
  <img
    src="assets/WatchGuard_Logo.svg"
    alt="logo"
    height="80"
    width="auto"
    class="logo"
  />
</div>
<div class="home-container">
  <div class="quiz-form-section-container-left">
    <div class="instruction">
      <app-instruction [proctorSetting]="candidateInfo.proctor_settings" (scrolledToEnd)="isScrolled($event)" [checkBox]="true">
      </app-instruction>
    </div>
    @if (checkBoxMsg) {
      <p>{{candidateFormUIString.read_instruction}}</p>
    }
  </div>
  <div class="quiz-form-section-container">
    <form class="candidate-form" [formGroup]="candidateDetailsForm">
      <div class="candidate-form-input">
				<p-floatLabel>
					<input
						id="test-name"
						type="text"
						formControlName="name"
						pInputText
					/>
					<label for="test-name">
						{{candidateFormUIString.test_name}}
					</label>
				</p-floatLabel>
        <small
          class="error-message"
          *ngIf="
            candidateDetailsForm.get('name')?.touched &&
            candidateDetailsForm.get('name')?.invalid
          "
        >
          Name is required.
        </small>
      </div>
      <div class="candidate-form-input">
				<p-floatLabel>
					<input
						id="email"
						type="email"
						formControlName="email"
						placeholder="Enter your Email"
						pInputText
        	/>
					<label for="email">
						{{candidateFormUIString.email}}
					</label>
				</p-floatLabel>
        <small
          class="error-message"
          *ngIf="
            candidateDetailsForm.get('email')?.touched &&
            !candidateDetailsForm.get('email')?.value
          "
        >
          Email is required.
        </small>
        <small
          class="error-message"
          *ngIf="
            candidateDetailsForm.get('email')?.value &&
            candidateDetailsForm.get('email')?.invalid
          "
        >
          Email is invalid.
        </small>
      </div>
      <div class="candidate-form-input">
        <p-floatLabel>
          <p-password
            id="password"
            name="password"
            required
            [feedback]="false"
            [toggleMask]="true"
            class="input"
            formControlName="password"
          />
          <label for="password">
            {{candidateFormUIString.password}}
          </label>
        </p-floatLabel>
        <small
          class="error-message"
          *ngIf="
            candidateDetailsForm.get('password')?.touched &&
            candidateDetailsForm.get('password')?.invalid
          "
        >
          Password is required.
        </small>
      </div>
      <div class="btn-center">
        <p-button
          type="submit"
          class="btn-design"
          severity="success"
          [label]="candidateFormUIString.start_test"
          [outlined]="true"
          [disabled]="(candidateDetailsForm.invalid )"
          (click)="openInstruction()"
        ></p-button>
      </div>
    </form>
  </div>
</div>
<p-dialog
  header="Test Instructions"
  [modal]="true"
  [(visible)]="showInstructions"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [closable]="false"
  [dismissableMask]="false"
  contentStyleClass="instruction-dialog-content"
>
  <div class="instruction-image">
    <img
      [src]="instructionImages[currentIndex]"
      alt="Instruction Slide"
      class="instruction-img"
    />
  </div>

  <div class="instruction-controls">
    <button
      pButton
      label="Previous"
      (click)="prevImage()"
      [disabled]="currentIndex === 0"
      class="nav-button"
    ></button>

    <button
      pButton
      label="Next"
      (click)="nextImage()"
      [disabled]="currentIndex === instructionImages.length - 1"
      class="nav-button"
    ></button>
  </div>

  <div
    class="instruction-confirm"
    *ngIf="currentIndex === instructionImages.length - 1"
  >
    <p-checkbox
      name="confirm"
      [(ngModel)]="hasReadInstructions"
      binary="true"
      inputId="readConfirm"
    >
    </p-checkbox>
    <label for="readConfirm">{{
      candidateFormUIString.instruction_confirmation
    }}</label>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      label="Start Test"
      (click)="startTest()"
      [disabled]="!hasReadInstructions"
      class="start-button"
    ></button>
  </ng-template>
</p-dialog>
